import { Avatar, Dropdown, Menu } from "antd";
import { ItemType } from "antd/lib/menu/hooks/useItems";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/auth";
import { doSignOut } from "../../firebase/auth";
import { getInitials } from "../../utils/helpers";
import { get } from "../../utils/helpers";
import ZoomVideo from "@zoom/videosdk";
import useHudsStatsStore from "../../store/slices/viewer/hudsStatsStore";

export const AppMenu = ({ className, isViewer = false, is404Page = false, url = false, handelVideoConfEnd = null, handleRejected = null,clearCancelNoise= null, editorDirectLogin=false, setHudsStateTwilio=null,zoomClient=null, isWaitingRoom = false, supportEmail,
  supportSubject, }: any, ) => {
  const [isSSO, setIsSSO] = useState(false);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);
  const navigate = useNavigate();
  const location: any = useLocation();
  const pathName = location.pathname;
  const user: any = useContext(AuthContext);
  const isLinkLogin = get(user,'linkLogin',false);
  const displayName = !isLinkLogin ? user?.displayName : `${get(user,'fn','')} ${get(user,'ln','')}`;
  const initials = getInitials(displayName);
  const adminPaths = ['/setuproom','/home','/profile','/changepassword','/resetpassword']
  const { setHudsState } = useHudsStatsStore();

  const signout = async () => {

    if(!!handelVideoConfEnd) {
      await handelVideoConfEnd()
    }

    if(zoomClient){
      ZoomVideo.destroyClient();
    }
    if(!!handleRejected){
      await handleRejected()
    }
    if(!!clearCancelNoise){
      clearCancelNoise()
    }
    await doSignOut();
    localStorage.removeItem('url')
    navigate(
      isLinkLogin
        ? "/viewerLogoutPage"
        : "/",
      { replace: true }
    );
  };

  useEffect(() => {
    if (!user) {
      navigate('/');
    } else if (!!user && isLinkLogin && adminPaths.includes(pathName)) {
      navigate('/404');
    }
  }, [user]);

  const accountSettinsPage = () => {
    navigate("/profile");
  };

  const changePassword = () => {
    navigate("/changepassword");
  };

  const needSupport = () => {
    const email = process.env.REACT_APP_SUPPORT_EMAIL || "support@pacpost.com";
    const subject = process.env.REACT_APP_SUPPORT_SUBJECT || "Support Request";
    const mailtoUrl = `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(subject)}`;
    
    if (zoomClient || isViewer) {
      window.open(mailtoUrl, "_blank", "noopener,noreferrer");
    } else {
      // On normal pages, use anchor element to avoid URL glitch
      const link = document.createElement('a');
      link.href = mailtoUrl;
      link.click();
    }
  };

  const manage2FA = () => {
    navigate("/manage2FA");
  };

  const invoice = ()=>{
    navigate("/invoice");
  }

  const openHudstats = () =>{
    if(setHudsStateTwilio){
      setHudsStateTwilio((prevState:any)=>({
        ...prevState,
        openHudStatsPanel:true
      }))
    }else{
      setHudsState({openHudStatsPanel:true})
    }
  }

  useEffect(() => {
    user?.providerData[0]?.providerId !== "password" && setIsSSO(true);
  }, [user]);

  useEffect(() => {
    const updateIsMobileOrTablet = () => {
      if (typeof window !== "undefined") {
        setIsMobileOrTablet(window.innerWidth <= 1366);
      }
    };

    updateIsMobileOrTablet();
    window.addEventListener("resize", updateIsMobileOrTablet);

    return () => {
      window.removeEventListener("resize", updateIsMobileOrTablet);
    };
  }, []);

  const menuItems = (
    isViewer:boolean,
    isSSO:boolean,
    is404Page:boolean
  ): ItemType[] => {
    const info: any[] = [
      { handler: accountSettinsPage, label: 'Account Settings', hide: isLinkLogin || editorDirectLogin||isViewer ||is404Page},
      { handler: changePassword, label: 'Change Password', hide: (isSSO || isLinkLogin || editorDirectLogin||isViewer|| is404Page)},
      { handler: manage2FA, label: 'Manage 2FA', hide: (isSSO || isLinkLogin) || editorDirectLogin||isViewer ||is404Page},
      { handler: invoice, label: 'Billing', hide:isLinkLogin || editorDirectLogin||isViewer ||is404Page},
      { handler: openHudstats, label: 'Media Stats',hide:  isWaitingRoom || !(isLinkLogin || editorDirectLogin)},
      { handler: needSupport, label: 'Need Support',hide:(is404Page || (isViewer && isMobileOrTablet))},
      { handler: signout, label: 'LogOut', hide: false}
    ]
    return info
      .filter(item => !item.hide)
      .map((item,i) => ({
        key: i,
        label: (
          <div onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            item.handler(e);
          }}>{item.label}</div>
        ),
      }))
  }
  const menu = (<Menu items={menuItems(isViewer,isSSO,is404Page)}/>)

  return !!user ? (
    <div className={className}>
      <Dropdown
        overlay={menu}
        placement="bottomRight"
        arrow
        trigger={["click"]}
        className={className}
      >
        <Avatar
          className="user-avatar"
          style={{ backgroundColor: "#f56a00", verticalAlign: "middle" }}
          size="large"
          gap={4}
        >
          {initials}
        </Avatar>
      </Dropdown>
    </div>
  ) : (
    <></>
  );
};